// features/menu/menuSlice.js

import { createSlice } from '@reduxjs/toolkit';

export const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    isOpen: false,
  },
  reducers: {
    toggle: state => {
      state.isOpen = !state.isOpen;
    },
    close: state => {
      state.isOpen = false;
    },
    open: state => {
      state.isOpen = true;
    }
  },
});

export const { toggle, close, open } = menuSlice.actions;

export default menuSlice.reducer;
